import React, { useState, useEffect } from 'react';
import { i18n } from 'next-i18next';
import { Slider } from '@lb-classroom/ui';
import TimeslotConstants from '../../../../constants/TimeslotConstants';
import Select from '../../../UI/atoms/form/Select';
import appUtils from '../../../../utils/appUtils';
import { withTranslation, WithTranslation } from 'next-i18next';
import { formatAddedDays } from '../../../../lib/date-utils';

interface TutorFilterMobileOwnProps {
  handleMoveRange?: (range: number[]) => void;
  updateChosenTimeRange?: (range: number[]) => void;
  updateChosenTime?: (time: string | number) => void;
  updateChosenDate?: (date: string | number | string[]) => void;
  updateChosenDuration?: (duration: string | number) => void;
  min?: number;
  max?: number;
  timeZone?: string;
  chosenDuration?: string | number;
  chosenDate?: string | number | string[];
  chosenTime?: string | number;
  chosenTimeRange?: number[];
}

type TutorFilterMobileProps = TutorFilterMobileOwnProps & WithTranslation;

const TIMESLOT_LIST = TimeslotConstants.slotArray;

const TutorFilterMobile = (props: TutorFilterMobileProps) => {
  const {
    t,
    timeZone,
    chosenDate,
    updateChosenDate,
    chosenDuration,
    updateChosenDuration,
    min = 1,
    max = 49,
    chosenTimeRange = [1, 49],
    handleMoveRange,
    updateChosenTimeRange,
  } = props;
  const language = i18n.language;
  const currentLocale = appUtils.getLocaleFromLang(language);
  const [localRange, setLocalRange] = useState(chosenTimeRange);

  useEffect(() => {
    setLocalRange(chosenTimeRange);
  }, [chosenTimeRange]);

  const getDateOptions = () => {
    const dateOptions = [];
    const now = new Date();
    let format = 'dddd, MMM D';
    if (currentLocale === 'ja') {
      format = 'M月D日 (ddd)';
    } else if (currentLocale === 'tw') {
      format = 'M月D日, ddd';
    } else if (currentLocale === 'es') {
      format = 'ddd D MMM';
    } else if (currentLocale === 'pt') {
      format = 'ddd, D \\d\\e MMM';
    } else if (currentLocale === 'ru') {
      format = 'ddd, D.M';
    }
    [0, 1, 2, 3].map((i) => {
      const sentence = formatAddedDays(now, i, timeZone, format, currentLocale);
      dateOptions.push({ key: i, name: sentence, value: i.toString() });
      return 0;
    });
    return dateOptions;
  };

  const getDurationOptions = () => {
    return [
      { key: '0', name: t('student.tutorList.twentyFiveMins'), value: '0' },
      { key: '1', name: t('student.tutorList.fiftyMins'), value: '1' },
    ];
  };

  const handleSliderChange = (value: number[]) => {
    setLocalRange(value);
    handleMoveRange?.(value);
  };

  const handleSliderCommit = (value: number[]) => {
    updateChosenTimeRange?.(value);
  };

  const chosenDateValue = chosenDate === null ? 4 : chosenDate;
  const dateFilterProps = {
    options: getDateOptions(),
    updateHandler: updateChosenDate,
    value: chosenDateValue,
  };
  const durationFilterProps = {
    options: getDurationOptions(),
    updateHandler: updateChosenDuration,
    value: chosenDuration,
  };

  return (
    <div className="tutor-filter-sm md:hidden">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12">
            <div className="mb-8 mt-8">
              <Select {...dateFilterProps} />
            </div>
            <div className="mb-4">
              <Select {...durationFilterProps} />
            </div>
            <div>
              <div className="relative px-2">
                <Slider
                  min={min}
                  max={max}
                  step={1}
                  value={localRange}
                  onValueChange={handleSliderChange}
                  onValueCommit={handleSliderCommit}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div className="col-span-6 mb-8">
                {TIMESLOT_LIST[localRange[0] - 1]}
              </div>
              <div className="col-span-6 mb-8 text-right">
                {TIMESLOT_LIST[localRange[1] - 1]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation('common')(TutorFilterMobile);
